// import { CircularProgress } from '@mui/material';
import React from 'react';
import { HelpIconInterface } from '../../utilities/contentful';
import HelpIconModal from './HelpIconModal';
import { Document } from '@contentful/rich-text-types';

interface Props {
  contentfulId: string;
  color: string;
  iconText?: string;
  helpIcons: HelpIconInterface[];
}

const HelpIcon = ({helpIcons, contentfulId, color, iconText}:Props): JSX.Element => {
  const thisIcon = helpIcons.find(icon => icon.sys.id === contentfulId);
  
  if (!thisIcon) return <></>

  return (
    <HelpIconModal title={thisIcon?.modalTitle as string} content={thisIcon?.modalContent.json as Document} color={color} iconText={iconText}></HelpIconModal>
  );
};

export default HelpIcon;
